import { render } from "./QuizResultView.vue?vue&type=template&id=161a9595&scoped=true"
import script from "./QuizResultView.vue?vue&type=script&lang=js"
export * from "./QuizResultView.vue?vue&type=script&lang=js"

import "./QuizResultView.vue?vue&type=style&index=0&id=161a9595&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161a9595"]])

export default __exports__